import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query WorkSSOLogin($code: String!, $businessId: String) {
    workSSOLogin(code: $code, businessId: $businessId) {
      accessToken
      user {
        uuid
      }
      business {
        uuid
        subdomain
      }
    }
  }
`

export const getLoginKey = getQueryNames(query)[0]

export default query
